import SearchFilter from './searchFilter.view';

export default SearchFilter;
